import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Alert
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { bindActionCreators, compose } from "redux";
import { orderAction } from "../../_actions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

class CancelOrderModal extends React.Component<
  {
    buttonLabel: any;
    id: any;
    style?: any;
  },
  any
> {
  constructor(props: any) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  toggle() {
    this.setState((prevState: any) => ({
      modal: !prevState.modal
    }));
  }

  handleValidSubmit(event: any, values: any) {
    this.toggle();
    this.props.cancelOrder(this.props.id);
    window.scrollTo(0, 0);
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Button
          color="danger"
          onClick={this.toggle}
          style={
            this.props.style
              ? this.props.style
              : { margin: "20px 0", float: "right" }
          }
        >
          {this.props.buttonLabel}
        </Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} style={{marginTop: "200px"}}>
          <ModalHeader toggle={this.toggle}>{t("prompt_cancel_order")}</ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={this.handleValidSubmit}>
              <div style={{ textAlign: "center", padding:"15px 0" }}>
                <Button
                  color="success"
                  type="submit"
                  style={{ minWidth: "200px" }}
                >
                  {t("confirm_cancel")}
                </Button>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    order: state.order
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      cancelOrder: orderAction.cancelOrder
    },
    dispatch
  );
};

const CancelOrderModalComponent = compose(
  withTranslation('orders'),
  connect(mapStateToProps,mapDispatchToProps)
)(CancelOrderModal);

export { CancelOrderModalComponent as CancelOrderModal };
